<template>
	<div>
		<hr>
		<div class="c-header-wrapper">
			<table class="header">
				<thead class='bold'>
					<tr>
						<td rowspan="4" class='c-td'>Субъекты, федеральные округа</td>
						<td colspan='7'>Количество Актов ЛПО, на которые были направлены заключения</td>
						<td class='c-scroll' rowspan="4"></td>
					</tr>
					<tr>
						<td rowspan="3" class='c-td'>Всего</td>
						<td rowspan="3" class='c-td'>положительных <br> (наличие в реестре <br> ГЛПМ)</td>
						<td colspan='5'>отрицательных</td>
					</tr>
					<tr>
						<td rowspan="2" class='c-td'>Всего</td>
						<td colspan='4'>в том числе по главным причинам</td>
					</tr>
					<tr>
						<td class='c-td'>несоответствия сведений данным государственного лесопатологического мониторинга (1)</td>
						<td class='c-td'>несоответствия сведений таксационным характеристикам лесного участка (2)</td>
						<td class='c-td'>несоответствия запланированных мероприятий санитарному и лесопатологическому состоянию лесов(3)</td>
						<td class='c-td'>запрещения или ограничения законодательством Российской Федерации запланированных мероприятий (4)</td>
					</tr>
					<tr>
						<td>1</td>
						<td>2</td>
						<td>3</td>
						<td>4</td>
						<td>5</td>
						<td>6</td>
						<td>7</td>
						<td>8</td>
					</tr>
				</thead>
			</table>
		</div>
		<div class="c-body-wrapper">
			<table class='body'>			
				<tbody>
					<tr v-for='(row, i) in rows'>
						<td v-if='row.flag' colspan="8"><span class="bold">{{row.fo}}</span></td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='left c-td'>{{row.region}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right c-td'>{{row.sending_conclusion}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right c-td'>{{row.decision_true}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right c-td'>{{row.decision_false}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right c-td'>{{row.decision_false_glpm}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right c-td'>{{row.decision_false_tax}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right c-td'>{{row.decision_false_som}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right c-td'>{{row.decision_false_law}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import router from '../../router'
	import {DB} from './../../constants'
	import { EventBus } from '../../lib/EventBus'

	const GET_CONCLUSION_REPORT = 'get_conclusion_report.php'
	const REPORT_ID = 2

	export default {
		name: 'Conclusion',
		data () {
			return {
				rows: []
			}
		},
		props: [
			'start',
			'end'
		],
		methods: {
			fillTable (start,end) {
				fetch(DB + GET_CONCLUSION_REPORT + '?start=' + start + '&end=' + end)
				.then(res => res.json())
				.then(res => {
					let temp_rows = [{}]
					let flag = true
					let total_summ = {}
					total_summ.region = 'Итого по РФ'
					total_summ.sending_conclusion = 0
					total_summ.decision_true = 0
					total_summ.decision_false = 0
					total_summ.decision_false_glpm = 0
					total_summ.decision_false_tax = 0
					total_summ.decision_false_som = 0
					total_summ.decision_false_law = 0

					let fo_summ = {}
					fo_summ.region = 'Итого по округу'
					fo_summ.sending_conclusion = 0
					fo_summ.decision_true = 0
					fo_summ.decision_false = 0
					fo_summ.decision_false_glpm = 0
					fo_summ.decision_false_tax = 0
					fo_summ.decision_false_som = 0
					fo_summ.decision_false_law = 0

					let i = 0

					while (i < res.length - 1) {

						if ((res[i].fo === res[i+1].fo) && flag) {
							let obj = {}
							obj.fo = res[i].fo
							obj.flag = true
							flag = false

							if (i !== 0) {
								let clone_fo = {} //клонируем объект для передачи по значению
								for (let key in fo_summ) {
									clone_fo[key] = fo_summ[key]
								}

								temp_rows.push(clone_fo)

								fo_summ.sending_conclusion = 0
								fo_summ.decision_true = 0
								fo_summ.decision_false = 0
								fo_summ.decision_false_glpm = 0
								fo_summ.decision_false_tax = 0
								fo_summ.decision_false_som = 0
								fo_summ.decision_false_law = 0
						}

						temp_rows.push(obj)

						
					}
					else {
						total_summ.sending_conclusion += +res[i].sending_conclusion
						total_summ.decision_true += +res[i].decision_true
						total_summ.decision_false += +res[i].decision_false
						total_summ.decision_false_glpm += +res[i].decision_false_glpm
						total_summ.decision_false_tax += +res[i].decision_false_tax
						total_summ.decision_false_som += +res[i].decision_false_som
						total_summ.decision_false_law += +res[i].decision_false_law

						fo_summ.sending_conclusion += +res[i].sending_conclusion
						fo_summ.decision_true += +res[i].decision_true
						fo_summ.decision_false += +res[i].decision_false
						fo_summ.decision_false_glpm += +res[i].decision_false_glpm
						fo_summ.decision_false_tax += +res[i].decision_false_tax
						fo_summ.decision_false_som += +res[i].decision_false_som
						fo_summ.decision_false_law += +res[i].decision_false_law

						temp_rows.push(res[i])
						if (res[i].fo !== res[i+1].fo) {
							flag = true
						}
						i++
					}
				}

				let last = res.length - 1
				temp_rows.push(res[last])

				total_summ.sending_conclusion += +res[last].sending_conclusion
				total_summ.decision_true += +res[last].decision_true
				total_summ.decision_false += +res[last].decision_false
				total_summ.decision_false_glpm += +res[last].decision_false_glpm
				total_summ.decision_false_tax += +res[last].decision_false_tax
				total_summ.decision_false_som += +res[last].decision_false_som
				total_summ.decision_false_law += +res[last].decision_false_law

				fo_summ.sending_conclusion += +res[last].sending_conclusion
				fo_summ.decision_true += +res[last].decision_true
				fo_summ.decision_false += +res[last].decision_false
				fo_summ.decision_false_glpm += +res[last].decision_false_glpm
				fo_summ.decision_false_tax += +res[last].decision_false_tax
				fo_summ.decision_false_som += +res[last].decision_false_som
				fo_summ.decision_false_law += +res[last].decision_false_law

				let clone_fo = {} //клонируем объект для передачи по значению
				for (let key in fo_summ) {
					clone_fo[key] = fo_summ[key]
				}

				temp_rows.push(clone_fo)

				temp_rows[0] = total_summ

				this.rows = temp_rows
			})
				.catch(err => console.log(err))
			}
		},
		mounted () {
			this.fillTable(this.start, this.end)

			EventBus.$on('conclusion-date', date => {
				// console.log('con',date)
				this.fillTable(date.start, date.end)
			})

			const dispay_width = document.documentElement.clientWidth
			const dispay_height = document.documentElement.clientHeight
			let scroll_width = 17

			const ua = navigator.userAgent

			if (ua.search('OPR/') > 0) {
				scroll_width = 15
			}

			const table_width = dispay_width - 30 - scroll_width
			const col_width = Math.round(table_width / 8)
			

			document.querySelectorAll('.c-td').forEach(td => {
				td.width = col_width
			})
			document.querySelector('.c-header-wrapper').width = table_width
			document.querySelector('.c-body-wrapper').width = table_width
			document.querySelector('.c-body-wrapper').style.maxHeight = `${dispay_height - 370}px`

			// console.log(dispay_height, dispay_width, col_width, table_width)
			// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

			document.querySelector('.c-scroll').width = scroll_width
		},
		created() {
			/*if(!this.$parent.$parent.reports.some((e) => {
				return e.id == REPORT_ID
			}))
				router.replace('/main')*/
		},
		beforeDestroy() {
			EventBus.$off('conclusion-date')
		}
	}
</script>

<style scoped>
	.left {
		text-align: left;
	}

	.right {
		text-align: right;
		padding-right: 10px;
	}

	div.c-header-wrapper {
		border: 1px solid black;
		border-bottom: none;  
		/*width: 1634px;*/
	}

	div.c-body-wrapper {
		overflow-x: hidden;
		overflow-y: auto;
		/*width: 1634px;*/
		/*max-height: 540px;*/
		border: 1px solid black;
		border-top: none;
	}

	table.header {
		border-bottom: 1px solid black;
		width: 100%;
	}

	table.body {
		table-layout: fixed;
		width: 100%;
	}

	td.c-td,  th.c-td {
		vertical-align: middle;  
		/*width: 202px;*/
		word-wrap: break-word;
	}

/* 	td.c-scroll {
	width: 15px;
} */
</style>


// WEBPACK FOOTER //
// Conclusion.vue?0a800d0e